module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "view"
  }, [_c('box', {
    attrs: {
      "label": 'Min arbejdstid seneste uge: ' + _vm.my_timelogs_this_week_hrs + ' t.'
    }
  }, [_c('table', {
    staticClass: "table-timespan-dates"
  }, [_c('tr', _vm._l((_vm.weekTimelogs_timespan), function(entry, i) {
    return _c('th', {
      key: 'affds' + i,
      attrs: {
        "data-day": entry.dayno
      }
    }, [_c('span', {
      staticClass: "l1"
    }, [_vm._v(_vm._s(entry.date.format('ddd')))]), _vm._v(" "), _c('span', {
      staticClass: "l2"
    }, [_vm._v(_vm._s(entry.date.format('D/M')))])])
  }), 0), _vm._v(" "), _c('tr', _vm._l((_vm.weekTimelogs_timespan), function(entry, i) {
    return _c('td', {
      key: 'afds' + i,
      attrs: {
        "data-day": entry.dayno
      }
    }, [_c('span', {
      staticClass: "l1"
    }, [_vm._v(_vm._s(entry.hours_logged))]), _vm._v(" "), _c('span', {
      staticClass: "l2"
    }, [_vm._v("timer")]), _vm._v(" "), _c('div', {
      staticClass: "bar",
      style: (_vm.barHeight(entry.hours_logged, _vm.weekTimelogs_timespan_maxhours))
    })])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "grid"
  }, [_c('div', {
    staticClass: "col m50"
  }, [_c('box', {
    attrs: {
      "label": 'Min arbejdstid i dag: ' + _vm.my_timelogs_today_hrs + ' t.'
    }
  }, [_c('template', {
    slot: "meta-r"
  }, [_c('div', {
    staticClass: "textlink",
    on: {
      "click": function($event) {
        return _vm.openTimelogger()
      }
    }
  }, [_vm._v("Log tid")])]), _vm._v(" "), _c('table', {
    staticClass: "table-a timelogs-table"
  }, [_c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v("Opgave")]), _vm._v(" "), _c('th', [_vm._v("Kunde")]), _vm._v(" "), _c('th', [_vm._v("Type")]), _vm._v(" "), _c('th', [_vm._v("Tid")]), _vm._v(" "), _c('th'), _vm._v(" "), _c('th')]), _vm._v(" "), _vm._l((_vm.my_timelogs_today), function(timelog, i) {
    return _c('tr', {
      key: 'ads' + i
    }, [_c('td', [_c('avatar', {
      attrs: {
        "input": _vm.getOne('project', timelog.project_key)
      }
    })], 1), _vm._v(" "), (_vm.getOne('project', timelog.project_key)) ? _c('td', [_c('router-link', {
      staticClass: "textlink",
      attrs: {
        "to": 'project/' + timelog.project_key
      }
    }, [_vm._v(_vm._s(_vm.getOne('project', timelog.project_key).name))])], 1) : _vm._e(), _vm._v(" "), (_vm.getClientFromTimelog(timelog)) ? _c('td', [_c('router-link', {
      staticClass: "textlink",
      attrs: {
        "to": 'client/' + _vm.getOne('project', timelog.project_key).client_key
      }
    }, [_vm._v(_vm._s(_vm.getClientFromTimelog(timelog).name))])], 1) : _vm._e(), _vm._v(" "), _c('td', [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm.translateWorktype(timelog.worktype)) + "\n\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(timelog.hours) + "\n\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "textlink",
      on: {
        "click": function($event) {
          return _vm.editTimelog(timelog)
        }
      }
    }, [_c('svgicon', {
      attrs: {
        "icon": "linearicons/pencil"
      }
    })], 1)]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "textlink",
      on: {
        "click": function($event) {
          return _vm.delete_timelog(timelog)
        }
      }
    }, [_c('svgicon', {
      attrs: {
        "icon": "linearicons/trash"
      }
    })], 1)])])
  })], 2), _vm._v(" "), (_vm.my_timelogs_today_invoicable_earning) ? _c('div', {
    staticClass: "align-c"
  }, [_c('br'), _vm._v("\n\t\t\t\t\tIndtjening: "), _c('b', [_vm._v(_vm._s(_vm._f("money")(_vm.my_timelogs_today_invoicable_earning)) + " kr.")])]) : _vm._e()], 2), _vm._v(" "), (_vm.is_user('wp')) ? _c('box', [_vm._v("WP todo: Vis economy nøgletal her i minibox.")]) : _vm._e(), _vm._v(" "), _c('masonry', [_c('div', {
    staticClass: "masonry-grid-item w1 h1"
  }, [_c('div', {
    staticClass: "snackbox clickable",
    on: {
      "click": function($event) {
        return _vm.goto('clients')
      }
    }
  }, [_c('div', {
    staticClass: "m up"
  }, [_c('svgicon', {
    attrs: {
      "icon": "linearicons/rocket"
    }
  }), _c('br'), _c('br')], 1), _vm._v(" "), _c('div', {
    staticClass: "b"
  }, [_vm._v("Kunder")])])]), _vm._v(" "), _c('div', {
    staticClass: "masonry-grid-item w1 h1"
  }, [_c('div', {
    staticClass: "snackbox clickable",
    on: {
      "click": function($event) {
        return _vm.goto('timeline')
      }
    }
  }, [_c('div', {
    staticClass: "m up"
  }, [_c('svgicon', {
    attrs: {
      "icon": "ionicons/ios-calendar-outline"
    }
  }), _c('br'), _c('br')], 1), _vm._v(" "), _c('div', {
    staticClass: "b"
  }, [_vm._v("Timeline")])])]), _vm._v(" "), _c('div', {
    staticClass: "masonry-grid-item w1 h1"
  }, [_c('div', {
    staticClass: "snackbox clickable",
    on: {
      "click": function($event) {
        return _vm.goto('timelogs')
      }
    }
  }, [_c('div', {
    staticClass: "m up"
  }, [_c('svgicon', {
    attrs: {
      "icon": "linearicons/pie-chart"
    }
  }), _c('br'), _c('br')], 1), _vm._v(" "), _c('div', {
    staticClass: "b"
  }, [_vm._v("Tidsforbrug")])])]), _vm._v(" "), _c('div', {
    staticClass: "masonry-grid-item w1 h1"
  }, [_c('div', {
    staticClass: "snackbox clickable",
    on: {
      "click": function($event) {
        return _vm.openTimelogger()
      }
    }
  }, [_c('div', {
    staticClass: "m up"
  }, [_c('svgicon', {
    attrs: {
      "icon": "linearicons/pie-chart"
    }
  }), _c('br'), _c('br')], 1), _vm._v(" "), _c('div', {
    staticClass: "b"
  }, [_vm._v("Log arbejdstid")])])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col m50"
  }, [_c('box', {
    attrs: {
      "label": "Mine aktive projekter"
    }
  }, [_c('table', {
    staticClass: "table-a timelogs-table"
  }, [_c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v("Opgave")]), _vm._v(" "), _c('th')]), _vm._v(" "), _vm._l((_vm.myActiveProjects), function(project, i) {
    return _c('tr', {
      key: 'fads' + i
    }, [_c('td', [_c('avatar', {
      attrs: {
        "input": project
      }
    })], 1), _vm._v(" "), _c('td', [_c('router-link', {
      staticClass: "textlink",
      attrs: {
        "title": project.client.name || 'Ingen kunde',
        "to": 'project/' + project.key
      }
    }, [_vm._v(_vm._s(project.name))])], 1), _vm._v(" "), _c('td', {
      staticClass: "align-r"
    }, [_c('div', {
      staticClass: "timelog-play-btn",
      on: {
        "click": function($event) {
          return _vm.openTimeloggerBasic({
            project_key: project.key
          })
        }
      }
    }, [_c('svgicon', {
      attrs: {
        "icon": "ionicons/ios-play"
      }
    })], 1)])])
  })], 2)]), _vm._v(" "), _c('box', {
    attrs: {
      "label": "Alle aktive projekter",
      "open": false,
      "header-toggle": ""
    }
  }, [_c('table', {
    staticClass: "table-a timelogs-table"
  }, [_c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v("Opgave")]), _vm._v(" "), _c('th')]), _vm._v(" "), _vm._l((_vm.allActiveProjects), function(project, i) {
    return _c('tr', {
      key: 'fads' + i
    }, [_c('td', [_c('avatar', {
      attrs: {
        "input": project
      }
    })], 1), _vm._v(" "), _c('td', [_c('router-link', {
      staticClass: "textlink",
      attrs: {
        "title": project.client.name || 'Ingen kunde...',
        "to": 'project/' + project.key
      }
    }, [_vm._v(_vm._s(project.name))])], 1), _vm._v(" "), _c('td', {
      staticClass: "align-r"
    }, [_c('div', {
      staticClass: "timelog-play-btn",
      on: {
        "click": function($event) {
          return _vm.openTimeloggerBasic({
            project_key: project.key
          })
        }
      }
    }, [_c('svgicon', {
      attrs: {
        "icon": "ionicons/ios-play"
      }
    })], 1)])])
  })], 2)]), _vm._v(" "), _c('box', {
    attrs: {
      "label": "Klar til fakturering"
    }
  }, [_c('table', {
    staticClass: "table-a timelogs-table"
  }, [_c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v("Opgave")]), _vm._v(" "), _c('th')]), _vm._v(" "), _vm._l((_vm.projects_invoice_ready), function(project, i) {
    return _c('tr', {
      key: 'fads' + i
    }, [_c('td', [_c('avatar', {
      attrs: {
        "input": project
      }
    })], 1), _vm._v(" "), _c('td', [_c('router-link', {
      staticClass: "textlink",
      attrs: {
        "title": project.client.name || 'Ingen kunde',
        "to": 'project/' + project.key
      }
    }, [_vm._v(_vm._s(project.name))])], 1), _vm._v(" "), _c('td', {
      staticClass: "align-r"
    }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm._f("money")(_vm.$store.getters['projects/get_payable_amount'](project), 2)) + " kr.\n\t\t\t\t\t\t")])])
  })], 2)]), _vm._v(" "), _c('box', {
    attrs: {
      "label": "Skyldige betalinger"
    }
  }, [_c('table', {
    staticClass: "table-a timelogs-table"
  }, [_c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v("Opgave")]), _vm._v(" "), _c('th', [_vm._v("Fakturering")]), _vm._v(" "), _c('th', {
    staticClass: "align-r"
  }, [_vm._v("Beløb")])]), _vm._v(" "), _vm._l((_vm.projects_money_owed), function(project, i) {
    return _c('tr', {
      key: 'fads' + i
    }, [_c('td', [_c('avatar', {
      attrs: {
        "input": project
      }
    })], 1), _vm._v(" "), _c('td', [_c('router-link', {
      staticClass: "textlink",
      attrs: {
        "title": project.client.name || 'Ingen kunde',
        "to": 'project/' + project.key
      }
    }, [_vm._v(_vm._s(project.name))])], 1), _vm._v(" "), _c('td', [(project.invoice_ready) ? _c('span', [_vm._v("Klar")]) : _c('span', [_vm._v("Ikke klar")])]), _vm._v(" "), _c('td', {
      staticClass: "align-r"
    }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm._f("money")(project.payable_amount, 0)) + " kr.\n\t\t\t\t\t\t")])])
  })], 2)])], 1)]), _vm._v(" "), (_vm.show_beta_content) ? _c('box', {
    attrs: {
      "label": "BETA"
    }
  }, [_c('p', [_vm._v("[Graf+liste visning over min tid denne uge fordelt på opgaver og arbejdstype]"), _c('br'), _c('br')]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "textlink",
    attrs: {
      "href": "https://trello.com/b/tAdvC4Vw/milk-studio",
      "target": "_blank"
    }
  }, [_vm._v("Link: Trello")]), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "textlink",
    attrs: {
      "href": "http://williampaix.com/projects/kia",
      "target": "_blank"
    }
  }, [_vm._v("Link: Kia v1")]), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "textlink",
    attrs: {
      "href": "https://console.firebase.google.com/u/0/project/kira-wpaix/database/data",
      "target": "_blank"
    }
  }, [_vm._v("Link: Firebase console")]), _c('br')]), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.gravatarurl('william.p.paix@gmail.com', 150),
      "alt": ""
    }
  })]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-637237b1","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Home.vue
// module id = 606
// module chunks = 1